import React from "react";
import { GeneralContainer, VideoContainer } from "./VideoComponent.styled";
import { ReactComponent as CloseIcon } from "../../../themes/Icons/close_icon.svg";
import { IconButton } from "@material-ui/core";

const VideoComponent = ({ source, handleHideVideo }) => {
  const uri = process.env.API_USER_GUIDE;

  return (
    <GeneralContainer>
      <VideoContainer>
        <IconButton className="close-btn" onClick={() => handleHideVideo()}>
          <CloseIcon />
        </IconButton>
        <video controls autoPlay>
          <source src={`${uri}/Videos?videoName=${source}`} type="video/mp4" />
        </video>
      </VideoContainer>
    </GeneralContainer>
  );
};

export default VideoComponent;
